var chevronUp = "https://shopfront-cdn.tekoapis.com/static/5a2fda8b57935427.svg";

export { chevronUp as default };
